import Vue from 'vue'
import Vuex from 'vuex'
import fps from 'fps';

const physics = {
  pipeRate: 2,
  pipeFrequency: 100,
  gravity: 0.22,
  jump: 4.6,
  flapRest: 10,
  flapActive: 5
}

const oringalPhysics = Object.assign({}, physics);

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    frameRate: {
      average: 0,
      gameSpeed: 60,
      min: 40
    },
    currentLevel: 1,
    frameRates: {
      temp: [],
      global: []
    },
    physics,
    best: 0
  },
  getters: {
    best: state => state.best,
    physics: state => state.physics,
    frameRate: state => state.frameRate,
    currentLevel: state => state.currentLevel
  },
  mutations: {
    getFrameRate(state) {
      const ticker = fps({
          every: 100   // update every x frames
      })
      
      setInterval(function() {
        ticker.tick()
      }, 1000 / 60)
      
      ticker.on('data', function(framerate) {
        state.frameRates.temp.push(Math.round(framerate));

        state.frameRates.global.push({
          timestamp: window.performance.now(),
          difference: 0
        })


        // measure short term fps averages
        if (state.frameRates.temp.length > 2) {

          state.frameRates.temp.splice(0,1);
          let sum = 0;

          for (let index = 0; index < state.frameRates.temp.length; index++) {
            sum += state.frameRates.temp[index];
          }

          state.frameRate.average = parseInt(sum / state.frameRates.temp.length);          
        }


        // If fps drops below min, change physics
        if (state.frameRate.average && state.frameRate.average < state.frameRate.min) {
          state.frameRate.gameSpeed = 30;
          state.physics = {
            pipeRate: 4,
            pipeFrequency: 50,
            gravity: .75,
            jump: 9.2,
            flapRest: 5,
            flapActive: 3
          }
        } else {
          state.physics = oringalPhysics;
          state.frameRate.gameSpeed = 60;
        }
        

        // Check if global object has been pushed atleast twice
        if (state.frameRates.global.length >= 2) {

          let global = state.frameRates.global;

          const difference = global[global.length - 1].timestamp - global[global.length - 2].timestamp;
          
          global[global.length - 1].difference = difference;

          let sum = 0;

          for (let index = 0; index < global.length; index++) {
            if (global[index] && global[index].difference) {
              sum += global[index].difference;
            }
          }

          // Detect if user leaves tab and comes back
          const averageTimestamp = sum / (global.length - 1);
          if (difference - 1000 > averageTimestamp) {
            state.frameRates.global = [];
            state.frameRates.temp = [];
            state.frameRate.average = 0;
          }

        }
      });
    },
    updateBest(state, newScore) {
      localStorage.setItem("best", newScore);
      state.best = newScore;
    }
  }
})
